import { createNotification } from "../graphql/mutations";
import { listNotifications } from "../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";

const createSubscription = async (
  user,
  category,
  county,
  munip,
  mail,
  categoryName
) => {
  if (category && county && munip) {
    const obj = {
      filter: {
        userId: { eq: user },
        category: { eq: category },
        county: { eq: county },
        municipality: { eq: munip },
        userEmail: { eq: mail },
      },
    };
    const listNotification = await API.graphql(
      graphqlOperation(listNotifications, obj)
    );
    /* console.log(
      "listNotifications: ",
      listNotification.data.listNotifications.items
    );*/
    const existingNotification = listNotification.data.listNotifications.items;

    if (existingNotification.length > 0) {
      // notificaiton exists already return info.
      //console.log("existingNotification: ", existingNotification);
    } else {
      //console.log("existingNotification ska vara null: ", existingNotification);

      //console.log("userId: ", user);
      try {
        const data = {
          input: {
            userId: user,
            category: category,
            county: county,
            municipality: munip,
            userEmail: mail,
            categoryName: categoryName,
          },
        };
        const promise = API.graphql(graphqlOperation(createNotification, data));
        promise.then(() => {
          return true;
        });
        promise.catch((error) => {
          console.log("Error in create subscription: ", error);
          return false;
        });
      } catch (e) {
        console.log("Error: ", e);
        return null;
      }
    }
  }
};

export default createSubscription;
